import {ApiService} from "./api.service";


export class DonorService extends ApiService{

  constructor(organizationId) {
    super();
    // this.endpoint = "/donors";
    this.endpoint = `/organizations/${organizationId}/donors`;
    this.per = 10;

  }
  donations(id, params) {
    const url = `${this.endpoint}/${id}/donations`;
    return super.get(url, params).then((res) => {
      return res.json;
    });
  }
}
